import type { GameFormValues } from './types'

/**
 * Regular season. The legacy create path backfills this when the admin never
 * touches the Game Type select; the edit path deliberately does NOT backfill.
 * See `buildGamePayload` — the asymmetry is intentional and preserved.
 */
export const DEFAULT_GAME_TYPE_ID = 2

/**
 * Fallback duration, in minutes.
 *
 * NOT pre-filled on create -- a new game starts with Duration empty so the
 * admin enters the real length rather than silently accepting 60. This is only
 * the fallback for an existing game whose stored `ends_at` is missing, where
 * the field would otherwise have nothing to show.
 */
export const DEFAULT_DURATION_MINUTES = 60

export const EMPTY_GAME_FORM: GameFormValues = {
  startsAt: '',
  durationMinutes: null,
  timeToBeDefined: false,
  homeTeamId: null,
  visitingTeamId: null,
  usePlaceholderVisitor: false,
  visitingTeamPlaceholder: '',
  venueId: null,
  facilityId: null,
  locationTimezone: null,
  gameNumber: '',
  // Pre-selected so the field SHOWS the default the payload would apply
  // anyway. Left null it saved as Regular Season while rendering empty, which
  // read as "nothing chosen" for a value that was in fact being sent.
  gameTypeId: DEFAULT_GAME_TYPE_ID,
  ifNecessaryStatus: false,
  isUpcomingLivestream: false,
  scheduleId: null,
}
